import { render, staticRenderFns } from "./TotalStudent.vue?vue&type=template&id=656062b8&functional=true&"
import script from "./TotalStudent.vue?vue&type=script&lang=js&"
export * from "./TotalStudent.vue?vue&type=script&lang=js&"
import style0 from "./TotalStudent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports